import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {Box, Button} from '../../styled';
import Timings from './Timings';

const TestMode = () => {
  const location = useLocation();
  const [isActive, setIsActive] = useState(false);

  const toggleActive = () => {
    setIsActive(!isActive);
  }

  if (location.pathname !== '/searchresults' &&
    (window.location.origin.indexOf('localhost') === -1 ||
    window.location.origin.indexOf('dev.gotrova.ai') === -1 ||
    window.location.origin.indexOf('stage.gotrova.ai') === -1)
  ) {
    return null;
  }
  return (
    <Box
      position="fixed"
      bottom="20px"
      right="20px"
      backgroundColor="white"
    >
      {!isActive ? (
        <Button
          border="1px solid blue"
          borderRadius={20}
          background="transparent"
          color="black"
          onClick={toggleActive}
        >
          T
        </Button>
      ) : (
        <Box
          border="1px solid gray"
          borderRadius={6}
          padding={2}
          width="150px"
        >
          <Timings />
          <Button
            background="transparent"
            color="blue"
            onClick={toggleActive}
            padding={0}
            border="none"
          >
            Close
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default TestMode;